import bemBlock from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import type React from "react";
import { BenefitsListGrid } from "./BenefitsListGrid";

function BenefitsListSectionComp(): React.ReactElement {
	const bem = bemBlock("benefits-list-section");
	return (
		<PageSection variant="solid-neutral" className={bem()}>
			<BenefitsListGrid />
		</PageSection>
	);
}

export const BenefitsListSection = withComponentErrorBoundary(
	BenefitsListSectionComp,
);
